jQuery(document).ready(function($) {
  function calculateNewMortgageTotal(propertyValue, depositAmount) {
    return (mortgageRequired = propertyValue - depositAmount)
  }

  function calculateNewRate(interestRate) {
    return (ratePerMonth = interestRate / 1200)
  }

  function calculatePayments() {
    var propertyValue = $('.value__property').data('price')
    var depositAmount = $('#deposit').val()
    var interestRate = $('#interestOutput').val()
    var mortgageTerm = $('#termOutput').val()
    mortgageRequired = calculateNewMortgageTotal(propertyValue, depositAmount)
    ratePerMonth = calculateNewRate(interestRate)
    monthlyRepayment =
      (mortgageRequired * ratePerMonth) /
      (1 - 1 / Math.pow(1 + ratePerMonth, mortgageTerm * 12))
    monthlyRepayment = Math.round(monthlyRepayment).toFixed(2)
    $('#mortgage-total').text(numberWithCommas(mortgageRequired))
    $('#repayments-value').text(numberWithCommas(monthlyRepayment))
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  $('#deposit').on('change', function() {
    calculatePayments()
  })

  $('#interestOutput').on('change', function() {
    calculatePayments()
  })

  $('#termOutput').on('change', function() {
    calculatePayments()
  })

  $(document).on('moved.zf.slider	', function() {
    calculatePayments()
  })

  // Init the calculation on load
  calculatePayments()

  // Add event listeners for changes to the form values and recalculate on change
})
